import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import Icon from "@Shared/components/general/fa-icon.vue";
import { computed, defineComponent, toRefs } from "@vue/composition-api";
import { useApplicationStoreGetters } from "@Broker/@Modules/clients/applications/application/store/application-helpers";
import * as ApplicationGetters from "@Broker/@Modules/clients/applications/application/store/application-getters";
import { useI18n } from "vue-i18n-composable";
export default defineComponent({
  components: {
    Icon
  },
  props: {
    visibilityPaths: {
      type: Array,
      required: true
    },
    applicantType: {
      type: String,
      default: ""
    }
  },
  setup(props, {
    emit
  }) {
    const {
      visibilityPaths,
      applicantType
    } = toRefs(props);
    const {
      t
    } = useI18n();
    const visibilityText = {
      hidden: t("settings.applicationForm.hiddenSection"),
      visible: t("settings.applicationForm.visibleSection")
    };
    const visibilityPathsWithApplicantType = computed(() => {
      var _context;
      return _mapInstanceProperty(_context = visibilityPaths.value).call(_context, path => path.replace("applicantType", applicantType.value));
    });
    const visibilityPathsToUse = computed(() => applicantType.value ? visibilityPathsWithApplicantType.value : visibilityPaths.value);
    const {
      fieldIsVisible
    } = useApplicationStoreGetters([ApplicationGetters.fieldIsVisible]);
    const isInvisible = computed(() => {
      return visibilityPathsToUse.value.every(path => !fieldIsVisible.value({
        paths: [path]
      }));
    });
    const eyeTooltipTitle = computed(() => {
      const option = isInvisible.value ? "hidden" : "visible";
      return visibilityText[option];
    });
    const handleMultipleVisibility = () => {
      emit("toggle-visibility", {
        paths: visibilityPathsToUse.value,
        multi: true,
        isVisible: isInvisible.value
      });
    };
    return {
      isInvisible,
      eyeTooltipTitle,
      handleMultipleVisibility,
      visibilityPathsToUse,
      visibilityPathsWithApplicantType
    };
  }
});